import { render, staticRenderFns } from "./YoutubeElement.vue?vue&type=template&id=0246dff0&scoped=true&"
import script from "./YoutubeElement.vue?vue&type=script&lang=ts&"
export * from "./YoutubeElement.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubeElement.vue?vue&type=style&index=0&id=0246dff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0246dff0",
  null
  
)

export default component.exports